import * as R from 'remeda'

import { type Question } from '~/hooks/useSurveyQuery'
import { type FiveSegmentCounts, toFiveSegmentCounts } from '~/utils'

import { type NineSegmentsAnswerData } from './buildNineSegmentsAnswersArrayData'
import { type FiveSegmentsData } from './fiveSegments'

export type FiveSegmentsAnswerData = FiveSegmentsData & {
  question: Question
  answerOption: { option: number; text: string }
}

export type FiveSegmentsAnswersArrayDataInput = {
  nineSegmentsAnswersArrayData: ReadonlyArray<
    ReadonlyArray<NineSegmentsAnswerData>
  >
  // Curried per-row builder from useGetFiveSegmentsData.
  getFiveSegmentsData: (
    fiveSegmentCounts: FiveSegmentCounts,
    total: number,
  ) => FiveSegmentsData
  // Sort function from useAtomValue(fiveSegmentSortFunctionAtom); basic-output
  // supplies identity for offline render. Mutable array param matches the
  // page's generic `<T extends FiveSegmentsData>(array: T[]) => T[]` signature.
  sort: (rows: FiveSegmentsAnswerData[]) => FiveSegmentsAnswerData[]
}

export const buildFiveSegmentsAnswersArrayData = (
  input: FiveSegmentsAnswersArrayDataInput,
): FiveSegmentsAnswerData[][] =>
  R.pipe(
    input.nineSegmentsAnswersArrayData,
    R.map((nineSegmentsAnswersData) =>
      R.pipe(
        nineSegmentsAnswersData,
        R.map((nineSegmentsAnswerData) => {
          const fiveSegmentCounts = toFiveSegmentCounts(
            nineSegmentsAnswerData.counts,
          )
          const total = nineSegmentsAnswerData.counts.total

          return {
            ...nineSegmentsAnswerData,
            ...input.getFiveSegmentsData(fiveSegmentCounts, total),
          }
        }),
        input.sort,
      ),
    ),
  )
